// main.js oder vuetify.js

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

import {createVuetify} from 'vuetify'
import {de} from 'vuetify/locale'

import {
    VApp,
    VAppBar,
    VAppBarNavIcon,
    VBtn,
    VCard,
    VCardText,
    VCardTitle,
    VChip,
    VCol,
    VContainer,
    VDataTableServer,
    VDialog,
    VDivider,
    VExpansionPanel,
    VExpansionPanels,
    VIcon,
    VLocaleProvider,
    VMain,
    VMenu,
    VNavigationDrawer,
    VOverlay,
    VProgressCircular,
    VRow,
    VSelect,
    VSheet,
    VSkeletonLoader,
    VSpacer,
    VTextarea,
    VTextField,
    VToolbar,
    VToolbarTitle,
    VTooltip,
    VTreeview,
    VTimePicker
} from 'vuetify/components'

import { VPie } from 'vuetify/labs/VPie'

import {generateGroupColors, generateStateColors} from "@/types/Order";

export default createVuetify({
    components: {
        VTimePicker,
        VApp,
        VAppBar,
        VAppBarNavIcon,
        VBtn,
        VCard,
        VCardTitle,
        VCardText,
        VChip,
        VCol,
        VContainer,
        VDataTableServer,
        VDialog,
        VDivider,           // ← hier drauf achten!
        VExpansionPanel,
        VExpansionPanels,
        VIcon,
        VLocaleProvider,
        VMain,
        VMenu,
        VNavigationDrawer,
        VOverlay,
        VProgressCircular,
        VRow,
        VSelect,
        VSkeletonLoader,
        VSheet,
        VSpacer,
        VTextField,
        VTextarea,
        VToolbar,
        VToolbarTitle,
        VTooltip,
        VTreeview,
        VPie
    },
    locale: {
        messages: {de},
        locale: 'de'
    },
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    primary: '#CE0058',
                    secondary: '#C3D6EE',
                    ternary: 'rgb(195,214,238)',
                    accent: '#141689',
                    info: '#A7A8AA',
                    background: '#ffffff',
                    surface: '#FFFFFF',
                    error: '#D32F2F',
                    success: '#4CAF50',
                    warning: '#FFC107',
                    btnColor: '#C3D6EE',
                    safety: '#f3d03e',
                    safetyBtnColor: '#f3d03e',
                    safetyBackground: '#fff9c4',
                    avatar: '#5c0a82',
                    toolbar: '#d0d0ce',
                    pro_rot: '#CE0058FF',
                    pro_hellblau: '#C3D6EEFF',
                    pro_dunkelblau: '#141689FF',
                    pro_dunkelgrau: '#A7A8AAFF',
                    text: '#000000',

                    // Neue Farben für bessere Theme-Unterstützung
                    'surface-variant': '#f5f5f5',
                    'on-surface': '#1a1a1a',
                    'on-surface-variant': '#424242',
                    'outline': '#757575',
                    'outline-variant': '#e0e0e0',
                    ...generateGroupColors(),
                    ...generateStateColors()
                },
            },
            dark: {
                colors: {
                    primary: '#CE0058',
                    secondary: '#5c0a82',
                    ternary: 'rgb(195,214,238)',
                    accent: '#C3D6EE',
                    info: '#D0D0CE',
                    background: '#1a1a1a',
                    surface: '#2d2d2d',
                    error: '#ff6b6b',
                    success: '#51cf66',
                    warning: '#ffd43b',
                    btnColor: '#141689',
                    safety: '#e2e868',
                    safetyBackground: '#3d3d1a',
                    avatar: '#141689',
                    textPrimary: '#ffffff',
                    textSecondary: '#A7A8AA',
                    border: '#404040',
                    hover: '#404040',
                    pro_rot: '#CE0058FF',
                    pro_hellblau: '#C3D6EEFF',
                    pro_dunkelblau: '#141689FF',
                    pro_dunkelgrau: '#A7A8AAFF',
                    text: '#FFFFFF',

                    // Dark Mode spezifische Farben
                    'surface-variant': '#3a3a3a',
                    'on-surface': '#ffffff',
                    'on-surface-variant': '#cccccc',
                    'outline': '#8a8a8a',
                    'outline-variant': '#404040',
                    ...generateGroupColors(),
                    ...generateStateColors()
                },
            },
        }
    },
})